"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _reactRedux = require("react-redux");

var _react = _interopRequireWildcard(require("react"));

var _UISubheader = _interopRequireDefault(require("UIComponents/layout/UISubheader"));

var _LoadingHOC = _interopRequireDefault(require("settings-ui-lib/components/hoc/LoadingHOC"));

var _actions = require("settings-ui-sdk/Domains/actions");

var _selectors = require("settings-ui-sdk/Domains/selectors");

var _TabsContainer = _interopRequireDefault(require("./TabsContainer"));

var DomainsContainer =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(DomainsContainer, _Component);

  function DomainsContainer() {
    (0, _classCallCheck2.default)(this, DomainsContainer);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DomainsContainer).apply(this, arguments));
  }

  (0, _createClass2.default)(DomainsContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      import('./sitemaps/SitemapsSettingsContainer');
      this.props.loadDomains();
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_LoadingHOC.default, {
        requestStatuses: [this.props.fetchDomainsRequestStatus],
        unrecoverableFailure: true
      }, _react.default.createElement(_UISubheader.default, {
        tabs: _react.default.createElement(_TabsContainer.default, null),
        title: _react.default.createElement(_FormattedMessage.default, {
          message: "marketing.domains.pageTitle"
        })
      }), this.props.children);
    }
  }]);
  return DomainsContainer;
}(_react.Component);

DomainsContainer.propTypes = {
  children: _react.PropTypes.node.isRequired,
  loadDomains: _react.PropTypes.func.isRequired,
  fetchDomainsRequestStatus: _react.PropTypes.string.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    fetchDomainsRequestStatus: (0, _selectors.getFetchDomainsRequestStatus)(state)
  };
};

var mapDispatchToProps = {
  loadDomains: _actions.loadDomains
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DomainsContainer);

exports.default = _default;
module.exports = exports.default;